<template>
  <v-dialog v-model="dialogComputed" scrollable persistent>
    <v-card>
      <v-card-title class="primary white--text py-2" primary-title>
        {{ inspDataViewOnly ? $t('ELE0206') : $t('ELE0255') }}
        <v-spacer />
        <Btn icon="mdi-close" @click="dialogComputed = false" depressed iconProp color="white" />
      </v-card-title>
      <v-card-text>
        <v-card outlined>
          <v-card-title class="pt-1 pb-1">
            {{ $t('ELE0177') }}
          </v-card-title>
          <v-card-text>
            <v-container class="px-0 py-0">
              <v-row>
                <v-col cols="5">
                  <InspecionCompanyInput :label="$t('ELE0048')" :value="inspCompanyCd" disabled />
                </v-col>
                <v-col cols="2">
                  <TextFieldRef :label="$t('ELE0031')" :value="partCd" />
                </v-col>
                <v-col>
                  <TextFieldRef :label="$t('ELE0032')" :value="partName" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5">
                  <TextFieldRef :label="$t('ELE0049')" :value="lotNo" />
                </v-col>
                <v-col cols="2">
                  <TextFieldInputWithDatePicker :label="$t('ELE0153')" :value="lotDate" :disabled="true" />
                </v-col>
                <v-col>
                  <InspCat1Input v-model="inspCat1" disabled />
                </v-col>
                <v-col>
                  <InspCat2Input v-model="inspCat2" disabled />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-card outlined>
                    <v-tabs fixed-tabs v-model="tabNo">
                      <v-tab class="ml-0" v-if="isIqc">{{ $t('ELE0073') }}</v-tab>
                      <v-tab class="ml-0">{{ $t('ELE0072') }}</v-tab>
                      <v-tab-item v-if="isIqc">
                        <v-card v-if="isIqc" outlined>
                          <v-data-table
                            :headers="headers"
                            :items="iqcItems"
                            dense
                            fixed-header
                            disable-pagination
                            hide-default-footer
                            height="290px"
                          >
                            <template v-slot:item.action="{ item }">
                              <IconInquiry @click="onClickInquiry(item)" />
                            </template>
                            <template v-slot:item.appDim="{ item }">
                              {{ getEnumlang('InspClassCd.', item.appDim) }}
                            </template>
                            <template v-slot:item.inspResultCd="{ item }">
                              <td :class="[`result-color-${item.inspResultCd}`, 'v-data-table__divider']">
                                {{ getInspResultName('InspResultCd.', item.inspResultCd, item.isOutCl) }}
                              </td>
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item>
                        <v-card class="mt-3" outlined>
                          <v-data-table
                            :headers="headers"
                            :items="oqcItems"
                            dense
                            fixed-header
                            disable-pagination
                            hide-default-footer
                            height="290px"
                          >
                            <template v-slot:item.action="{ item }">
                              <IconInquiry @click="onClickInquiry(item)" />
                            </template>
                            <template v-slot:item.appDim="{ item }">
                              {{ getEnumlang('InspClassCd.', item.appDim) }}
                            </template>
                            <template v-slot:item.inspResultCd="{ item }">
                              <td :class="[`result-color-${item.inspResultCd}`, 'v-data-table__divider']">
                                {{ getInspResultName('InspResultCd.', item.inspResultCd, item.isOutCl) }}
                              </td>
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-tab-item>
                    </v-tabs>
                  </v-card>
                </v-col>
              </v-row>
              <v-card flat v-if="!isInquiry && !inspDataViewOnly">
                <v-card-text>
                  <v-row>
                    <v-col class="d-flex flex-row justify-end">
                      <Btn
                        class="mx-2"
                        :label="$t('ELE0216')"
                        @click="onClickCheck"
                        isCheckRole
                        :disabled="!canCheck"
                      />
                      <Btn
                        class="mx-2"
                        :label="$t('ELE0215')"
                        @click="onClickApprove"
                        isCheckRole
                        :disabled="!canApprove"
                      />
                      <Btn
                        class="ml-2"
                        :label="$t('ELE0250')"
                        @click="onClickReturn"
                        isCheckRole
                        :disabled="!canReturnToRequest"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-container>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
    <ApprovalInspDataDtlDialog
      v-if="inspDtlDialog"
      :dialog.sync="inspDtlDialog"
      :inspIndexNo="inspResult.inspIndexNo"
      :inspCompanyCd="inspResult.inspCompanyCd"
      :cav="inspResult.cav"
      :numOfInsp="inspResult.numOfInsp"
      :appDim="inspResult.appDim"
      :inspDataViewOnly="inspDataViewOnly"
    />
    <ConfirmDialog
      v-if="confirmDialog"
      :dialog.sync="confirmDialog"
      :confirmWord="$t('MSG0084')"
      :btnLabel="$t('ELE0250')"
      @proceed="processReturn"
      @cancel="cancelReturn"
    />
  </v-dialog>
</template>

<script>
import { API } from '@/plugins/api'
import { ApproveStatusCd } from '@/enum.js'

import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtil from '@/mixin/date-utils.js'
import StringUtils from '@/mixin/string-utils.js'

import Btn from '@/components/atoms/base/button/Btn'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import IconInquiry from '@/components/atoms/icon/IconInquiry'
import InspecionCompanyInput from '@/components/atoms/select/InspecionCompanyInput'
import ApprovalInspDataDtlDialog from '@/components/organisms/terminal/dialog/ApprovalInspDataDtlDialog'
import ConfirmDialog from '@/components/organisms/common/dialog/ConfirmDialog'
import InspCat1Input from '@/components/atoms/select/InspCat1Input'
import InspCat2Input from '@/components/atoms/select/InspCat2Input'

const TabNo = {
  OQC: '0',
  IQC: '1',
}
export default {
  name: 'ApprovalInspDataListDialog',

  mixins: [APIUtils, Message, Loading, DateUtil, StringUtils],
  components: {
    Btn,
    TextFieldInputWithDatePicker,
    TextFieldRef,
    IconInquiry,
    InspecionCompanyInput,
    ApprovalInspDataDtlDialog,
    ConfirmDialog,
    InspCat1Input,
    InspCat2Input,
  },

  data() {
    return {
      inspDtlDialog: false,
      confirmDialog: false,
      isIqc: null,
      tabNo: 0,
      headers: [
        { text: '', value: 'action', divider: true, width: '30', sortable: false },
        { text: this.$t('ELE0437'), value: 'inspTimingDtlName', divider: true, width: '200' },
        { text: this.$t('ELE0157'), value: 'cav', divider: true, width: '100' },
        { text: this.$t('ELE0156'), value: 'appDim', divider: true, width: '100' },
        { text: this.$t('ELE0098'), value: 'numOfInsp', divider: true, width: '170', align: 'end' },
        { text: this.$t('ELE0138'), value: 'inspDate', divider: true },
        { text: this.$t('ELE0181'), value: 'inspResultCd', divider: true },
        { text: this.$t('ELE0154'), value: 'inspector', divider: true },
        { text: this.$t('ELE0137'), value: 'inspIndexNo' },
      ],
      oqcItems: [],
      iqcItems: [],
      inspResult: {},
      canReturnRequest: true,
    }
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    inspIndexNo: {
      type: String,
      required: true,
    },
    inspCompanyCd: {
      type: String,
      required: true,
    },
    lotNo: {
      type: String,
      required: true,
    },
    partCd: {
      type: String,
      required: true,
    },
    partName: {
      type: String,
      required: true,
    },
    lotDate: {
      type: String,
      required: true,
    },
    wfNo: {
      type: Number,
      required: false,
      default: 0,
    },
    wfVersionNo: {
      type: Number,
      required: false,
      default: 0,
    },
    inspIndexVersionNo: {
      type: Number,
      required: false,
      default: 0,
    },
    statusCd: {
      type: String,
      required: false,
      default: '',
    },
    canCheck: {
      type: Boolean,
      required: false,
      default: false,
    },
    canApprove: {
      type: Boolean,
      required: false,
      default: false,
    },
    canReturnToRequest: {
      type: Boolean,
      required: false,
      default: false,
    },
    isInquiry: {
      type: Boolean,
      required: false,
      default: false,
    },
    inspDataViewOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    inspCat1: {
      type: String,
      required: false,
      default: '',
    },
    inspCat2: {
      type: String,
      required: false,
      default: '',
    },
  },

  watch: {
    async dialog() {
      if (this.dialog == true) {
        await this.search()
      }
    },
  },

  computed: {
    enumApproveStatusCd: () => ApproveStatusCd,
    enumTabNo: () => TabNo,
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },

  methods: {
    close() {
      this.dialogComputed = false
      this.$emit('close')
    },
    onClickInquiry(item) {
      this.inspResult = {
        inspIndexNo: item.inspIndexNo,
        inspCompanyCd: this.inspCompanyCd,
        cav: item.cav,
        numOfInsp: item.numOfInsp,
        appDim: item.appDim,
      }
      this.inspDtlDialog = true
    },
    async search() {
      this.startLoading()
      try {
        const params = {
          inspIndexNo: this.inspIndexNo,
        }
        const elements = await API.get('/inspIndex/approves/inspResultList', params)
        this.isIqc = elements['isIqc']
        this.iqcItems = elements['iqcResultList']
        this.oqcItems = elements['oqcResultList']
        this.canReturnRequest = elements['canReturnRequest']
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0217') })))
      } finally {
        this.stopLoading()
      }
    },
    async onClickCheck() {
      this.startLoading()
      try {
        if (this.statusCd != ApproveStatusCd.WAITING_FOR_CHECK) {
          this.setErrorMessage(
            this.$t('MSG0082', { p0: this.$t(`ApproveStatusCd.${ApproveStatusCd.WAITING_FOR_CHECK}`) }),
          )
          return
        }
        const body = {
          wfList: [
            {
              wfNo: this.wfNo,
              versionNo: this.wfVersionNo,
            },
          ],
          userCd: this.$store.getters.userCd,
        }
        await API.post('/inspIndex/approves/check/', body)
        this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0139') }))
        this.close()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0217') })))
      } finally {
        this.stopLoading()
      }
    },
    async onClickApprove() {
      this.startLoading()
      try {
        if (this.statusCd != ApproveStatusCd.WAITING_FOR_APPROVE) {
          this.setErrorMessage(
            this.$t('MSG0082', { p0: this.$t(`ApproveStatusCd.${ApproveStatusCd.WAITING_FOR_APPROVE}`) }),
          )
          return
        }
        const body = {
          wfList: [
            {
              wfNo: this.wfNo,
              versionNo: this.wfVersionNo,
            },
          ],
          userCd: this.$store.getters.userCd,
        }
        await API.post('/inspIndex/approves/approve/', body)
        this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0139') }))
        this.close()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0217') })))
      } finally {
        this.stopLoading()
      }
    },
    onClickReturn() {
      if (this.canReturnRequest) {
        this.confirmDialog = true
      } else {
        this.setErrorMessage(this.$t('MSG0162'))
      }
    },
    cancelReturn() {
      this.confirmDialog = false
    },
    async processReturn() {
      this.startLoading()
      try {
        const body = {
          wfNo: this.wfNo,
          inspIndexVersionNo: this.inspIndexVersionNo,
        }
        await API.post(`/inspIndex/approves/${this.inspIndexNo}/returnToRequest/`, body)
        this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0139') }))
        this.close()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0217') })))
      } finally {
        this.stopLoading()
      }
    },
    getEnumlang(key, value) {
      // langのenumからメッセージ取得
      let lang = ''
      if (value) {
        lang = this.$t(key + value)
      }
      return lang
    },
  },

  async mounted() {
    await this.search()
  },
}
</script>
<style>
.result-color-1 {
  background-color: #edeffd;
}
.result-color-2 {
  background-color: #fcf4a1;
}
.result-color-9 {
  background-color: #f8ced2;
}
</style>
